import { useQuery } from "@tanstack/react-query";
import { getClinicianData } from "lib/api/firebase/apis/apis";
import { queryKeyFactory } from "lib/utils/queryKeyFactory";

export function useGetCurrentClinicianInfo(clinicianId: string | undefined) {
    return useQuery({
        queryKey: queryKeyFactory.clinician.data(clinicianId!),
        queryFn: () => getClinicianData().then(_ => _.data),
        enabled: clinicianId !== undefined
    })
}